/**
 * Single source for the browser-facing API base URL.
 * Set VITE_API_URL in frontend/.env* or in CI for `npm run build`.
 * VITE_API_BASE_URL is supported as a legacy alias.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

/**
 * Prefix for routes mounted under /api but not under /api/v1 (e.g. /api/internal/wake).
 */
export const API_ROOT = API_BASE_URL.replace(/\/v1\/?$/, '') || '/api';
